import * as React from 'react';

import { Tooltip, TooltipProps, tooltipClasses, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface NarrativeTooltipProps {
  narrative: string;
  cutoffWidth?: number;
}

const WideTooltip = styled(({ className, children, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }}>
    {children}
  </Tooltip>
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 800,
  },
});

function NarrativeTooltip({ narrative, cutoffWidth = 100 }: NarrativeTooltipProps): JSX.Element {
  if (narrative.length < cutoffWidth) {
    return (
      <span>{narrative}</span>
    );
  }

  return (
    <WideTooltip
      arrow
      title={(
        <Typography>
          {narrative}
        </Typography>
      )}
    >
      <Box
        textOverflow="ellipsis"
        overflow="hidden"
        height="1.5em"
      >
        <Typography
          variant="subtitle1"
        >
          {narrative}
        </Typography>
      </Box>
    </WideTooltip>
  );
}

export default NarrativeTooltip;
